import { __rest, __assign } from 'tslib';
import React from 'react';
import { ListBottomSheetMobile } from './list-bottom-sheet-mobile.js';
import { ListModalMobile } from './list-modal-mobile.js';

var ListMobile = function (props) {
    var baseProps = props.baseProps, restProps = __rest(props, ["baseProps"]);
    var isBottomSheet = baseProps.isBottomSheet, nativeSelect = baseProps.nativeSelect;
    if (isBottomSheet && !nativeSelect) {
        return (React.createElement(ListBottomSheetMobile, __assign({}, baseProps, restProps)));
    }
    if (!isBottomSheet && !nativeSelect) {
        return React.createElement(ListModalMobile, __assign({}, baseProps, restProps));
    }
    return null;
};

export { ListMobile };
